/* Comportements de la LP CrossHold — transcription des runtimes GemPages de la source.
   Chaque contrat ci-dessous a ete releve DEUX FOIS : dans le script minifie du concurrent
   (`_audit/gp-*.js`) et sur la source rendue au banc local, aux largeurs reelles.
   On ne charge aucun script du concurrent : ces 4 comportements sont tout ce qu'ils faisaient.

   1. COMPTE A REBOURS  (2 instances)  -> gp-countdown-v7-5.js, `behaviour:"daily"`
   2. ACCORDEON         (9 items)      -> gp-accordion-v7-5.js, `expandedMode:"multiple"`
   3. CARROUSEL         (3 slides)     -> gp-carousel-v3-v7-5.js, moteur SWIPER
   4. BOUTON            (1)            -> AUCUN JS : `type:"open-page"`, le <a href> suffit.
*/
(function () {
  'use strict';

  /* Les 4 sections referencent ce meme fichier : il est EXECUTE 4 fois. Sans cette garde, chaque
     rebours recevrait 4 setInterval et chaque carrousel 4 jeux de clones. Le `defer` pose sur les
     balises garantit par ailleurs que le DOM entier est parse au premier passage, donc qu'une
     seule execution suffit a amorcer les quatre sections. */
  if (window.__crossholdShortsAmorce) return;
  window.__crossholdShortsAmorce = true;

  var ROOT = '.lyscs';

  function all(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }

  /* ------------------------------------------------------------------ 1. REBOURS
     `timerDaily = {format:"am", hours:0, mins:0}` : la source vise 00:00 LOCAL.
     Transcription de `T()` : cible = aujourd'hui a 0 h 0 ; si deja passee, +24 h.
     Affichage : `enableDay:false` donc l'heure affichee est le TOTAL d'heures
     (0-23 ici), la minute et la seconde sont les restes. `y()` -> 2 chiffres. */
  function secondesJusquaMinuit() {
    var now = new Date();
    var cible = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0).getTime();
    var d = cible - now.getTime();
    if (d < 0) d += 86400000;
    return Math.ceil(d / 1000);
  }

  function pad(n) {
    if (isNaN(n) || n === 0) return '00';
    return n < 10 ? '0' + n : String(n);
  }

  function rebours(el) {
    var h = el.querySelector('#hour .gp-countdown-number');
    var m = el.querySelector('#minute .gp-countdown-number');
    var s = el.querySelector('#second .gp-countdown-number');
    if (!h && !m && !s) return;
    var reste = secondesJusquaMinuit();
    function peindre() {
      var v = Math.max(reste, 0);
      if (h) h.textContent = pad(Math.floor(v / 3600));
      if (m) m.textContent = pad(Math.floor(v / 60) % 60);
      if (s) s.textContent = pad(v % 60);
    }
    peindre();
    var t = setInterval(function () {
      reste -= 1;
      peindre();
      // `loopAfterFinish` n'agit qu'en mode "evergreen" : en daily la source s'arrete a 00:00:00.
      if (reste <= 0) clearInterval(t);
    }, 1000);
  }

  /* ---------------------------------------------------------------- 2. ACCORDEON
     `expandItem:false` -> tout est replie au chargement (etat deja servi en HTML).
     `expandedMode:"multiple"` -> chaque item est independant, et un clic sur un item
     ouvert le referme. La source anime sur 500 ms (`gp-duration-500`) ; le corps est
     une grille dont on bascule `grid-template-rows` entre `0fr` et `1fr`.
     L'icone est remplacee : caret-bas replie -> caret-haut deplie (`iconCollapse`/
     `iconExpand` de `gp-data`, repris ici a l'identique). */
  var CARET_BAS = '\n          <svg width="16" height="16" data-name="Caret-down-regular" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M4.57576 6.77571C4.81007 6.5414 5.18997 6.5414 5.42429 6.77571L8.20002 9.55145L10.9758 6.77571C11.2101 6.5414 11.59 6.5414 11.8243 6.77571C12.0586 7.01003 12.0586 7.38993 11.8243 7.62424L8.62429 10.8242C8.38997 11.0586 8.01007 11.0586 7.77576 10.8242L4.57576 7.62424C4.34145 7.38993 4.34145 7.01003 4.57576 6.77571Z" fill="currentColor"/>\n</svg>\n          ';
  var CARET_HAUT = '\n       <svg width="16" height="16" data-name="Caret-up-regular" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M11.6243 9.82426C11.39 10.0586 11.0101 10.0586 10.7758 9.82426L8.00005 7.04853L5.22431 9.82426C4.99 10.0586 4.6101 10.0586 4.37579 9.82426C4.14147 9.58995 4.14147 9.21005 4.37579 8.97574L7.57579 5.77574C7.8101 5.54142 8.19 5.54142 8.42431 5.77574L11.6243 8.97574C11.8586 9.21005 11.8586 9.58995 11.6243 9.82426Z" fill="currentColor"/>\n</svg>\n';

  function accordeon(el) {
    all('.gp-accordion-item', el).forEach(function (item) {
      var head = item.querySelector('.gp-accordion-item_header');
      var body = item.querySelector('.gp-accordion-item_body');
      var icon = item.querySelector('.gp-accordion-item_icon');
      if (!head || !body) return;
      body.style.gridTemplateRows = '0fr';
      body.setAttribute('data-show', 'false');
      head.setAttribute('role', 'button');
      head.setAttribute('tabindex', '0');
      head.setAttribute('aria-expanded', 'false');

      function bascule() {
        var ouvert = body.getAttribute('data-show') === 'true';
        body.setAttribute('data-show', ouvert ? 'false' : 'true');
        body.style.gridTemplateRows = ouvert ? '0fr' : '1fr';
        head.setAttribute('aria-expanded', ouvert ? 'false' : 'true');
        if (icon) icon.innerHTML = ouvert ? CARET_BAS : CARET_HAUT;
      }
      head.addEventListener('click', bascule);
      head.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); bascule(); }
      });
    });
  }

  /* ---------------------------------------------------------------- 3. CARROUSEL
     Le moteur de la source est SWIPER (le conteneur recoit `swiper-initialized
     swiper-horizontal swiper-watch-progress swiper-backface-hidden`), pas keen-slider.
     Il ne defile PAS en `scroll-snap` : il translate la piste en `transform:
     translate3d(x,0,0)`. Tout ce qui suit est releve sur la source au banc local
     (2026-09-10), runtime du concurrent actif, aux deux largeurs ou le carrousel existe.

     390 px — `loop.mobile:true`
       cadre 350 · slide 244.851 (`calc(100%/1.4 - 5.142857px)`) · marge droite 18
       -> pas 262.851 · retrait lateral (350-244.851)/2 = 52.574
       6 noeuds : les 3 slides sont DUPLIQUEES UNE FOIS, a la suite -> [A,B,C,A,B,C]
       la slide active reste au rang 3 du DOM, transform au repos -736 px
       (= 52.574 - 3 x 262.851), 3 puces.
       Un `suivant` = animer 500 ms vers le rang 4, PUIS faire tourner le DOM d'un cran
       et remettre le transform au repos en 0 ms : la position visuelle ne bouge pas.

     768 px — `loop.desktop:false` (la tablette herite du desktop)
       cadre 285.695 · slide 286 (`calc(100%/1 - 0px)`) · marge droite 16 -> pas 302
       3 noeuds, aucune duplication, aucun retrait : positions 0 / -302 / -604,
       la derniere bornee par la fin de piste. 4 PUCES pour 3 positions : la 4e n'est
       jamais active, un clic dessus retombe sur la 3e.
       La fleche GAUCHE recoit `visibility:hidden !important` a la position 0 ; la fleche
       DROITE n'est JAMAIS masquee, meme en butee (verifie deux fois).

     >= 1025 px : la rangee porte `--d:none`, le carrousel N'EXISTE PAS en desktop.

     Deux ecarts assumes, tous deux invisibles au rendu et sans regle CSS qui les lise
     (verifie : 0 occurrence de `swiper`, `active-index`, `gem-slider-dot` dans la
     feuille livree comme dans le theme) :
       - on ne repose pas les classes de comptabilite interne de Swiper (`swiper-*`) ;
       - apres un `precedent`, la source se repose au rang 2 et nous au rang 3. Comme la
         piste est [A,B,C,A,B,C], les deux rangs portent le MEME contenu : meme image
         centree, memes voisines.

     Les puces sont fabriquees par le script (le conteneur est vide en HTML). Gabarit
     releve caractere par caractere sur la source, y compris les deux variables
     `--tw-shadow` que Tailwind pose et que j'avais omises. */
  var DOT_ACTIVE_BG = 'var(--g-c-line-3, line-3)';
  var DOT_BG = 'var(--g-c-bg-1, bg-1)';
  var VITESSE = 500;   // mesure : transition-duration 500ms, courbe `ease`

  function puce(cid, k, actif) {
    return '<button type="button" id="gp-dot-item-' + cid + '-' + k + '" data-index="' + k +
      '" aria-label="dot" style="background-color: ' + (actif ? DOT_ACTIVE_BG : DOT_BG) +
      '; aspect-ratio: 1/1; width: 12px; border-radius: 9999px;' +
      ' box-shadow: 0 4px 6px -1px rgba(0,0,0,.1);' +
      ' --tw-shadow: 0 2px 4px -2px rgba(0,0,0,.1);' +
      ' --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color),0 2px 4px -2px var(--tw-shadow-color);"' +
      ' class="gp-carousel-dot' +
      (actif ? ' gp-carousel-dot--active gem-slider-dot-active' : ' gem-slider-dot-inactive') +
      '"></button>';
  }

  function carrousel(el) {
    var cid = el.getAttribute('data-id') || '';
    var piste = el.querySelector('.gem-slider-wrapper');
    if (!piste) return;
    var cadre = piste.parentElement;                       // le div a `overflow:hidden`
    var dots = el.querySelector('.gp-carousel-dot-container');
    var flPrec = el.querySelector('.gp-carousel-action-back');
    var flSuiv = el.querySelector('.gp-carousel-action-next');
    var origines = all(':scope > .gem-slider-item', piste);
    var n = origines.length;
    if (!n) return;

    var boucle = false;      // etat courant (mobile = true)
    var courant = 0;         // index LOGIQUE de la slide vue, 0..n-1
    var rang = 0;            // index DOM de repos (n en boucle, sinon = courant)
    var slideW = 0, mr = 0, pas = 0, retrait = 0, cadreW = 0;
    var finAnim = null;

    /* -------- geometrie. La largeur de la piste doit etre EPINGLEE a celle du cadre :
       les slides sont dimensionnees en `calc(100%/1.4 - …)` DE LA PISTE. Sans cet
       epinglage, une piste flex sans retour a la ligne s'etire a son contenu et le
       pourcentage se resout sur une base fausse. La source pose `width:<cadre>px !important`. */
    function mesurer() {
      cadreW = cadre.clientWidth;
      if (!cadreW) return false;
      piste.style.setProperty('width', cadreW + 'px', 'important');
      var r = piste.firstElementChild.getBoundingClientRect();
      slideW = r.width;
      mr = parseFloat(getComputedStyle(piste.firstElementChild).marginRight) || 0;
      pas = slideW + mr;
      retrait = boucle ? (cadreW - slideW) / 2 : 0;
      return pas > 0;
    }

    function butee() {
      var total = n * (boucle ? 2 : 1) * pas - mr;         // pas de marge apres la derniere
      return Math.min(0, -(total - cadreW));
    }

    function positionDe(i) {
      var x = retrait - i * pas;
      return boucle ? x : Math.max(butee(), Math.min(0, x));
    }

    function placer(x, duree) {
      piste.style.transitionProperty = 'transform';
      piste.style.transitionDelay = '0ms';
      piste.style.transitionDuration = duree + 'ms';
      piste.style.transform = 'translate3d(' + x + 'px, 0px, 0px)';
    }

    function tourner(sens) {
      if (sens > 0) piste.appendChild(piste.firstElementChild);
      else piste.insertBefore(piste.lastElementChild, piste.firstElementChild);
    }

    function poserClones(actif) {
      all(':scope > [data-gp-clone]', piste).forEach(function (c) { c.remove(); });
      // remettre les originales dans l'ordre : une rotation a pu les deplacer
      origines.forEach(function (s) { piste.appendChild(s); });
      if (!actif) return;
      origines.forEach(function (s) {
        var c = s.cloneNode(true);
        c.setAttribute('data-gp-clone', '1');
        piste.appendChild(c);
      });
    }

    function peindre() {
      if (dots) {
        /* Compte RELEVE sur la source aux trois largeurs, cadre mesure a la meme seconde :
             390  -> 3 puces, cadre 350, piste bouclee a 6 noeuds
             768  -> 4 puces, cadre 292, 3 noeuds  (la 4e n'est jamais active)
            1440  -> 3 puces, cadre 0,   3 noeuds
           A 1025+ la rangee porte `--d:none` : le cadre mesure 0, Swiper ne resout pas son
           `slidesPerView` et retombe a une puce par slide. La 4e puce de la tablette naît donc
           de la GEOMETRIE, pas du palier -- elle disparaît des que le cadre n'est plus mesurable. */
        var np = boucle ? n : (cadreW ? n + 1 : n);
        var html = '';
        for (var k = 0; k < np; k++) html += puce(cid, k, k === courant);
        dots.innerHTML = html;
      }
      // mesure : seule la fleche gauche se masque, et seulement hors boucle a la position 0.
      if (flPrec) {
        if (!boucle && courant === 0) flPrec.style.setProperty('visibility', 'hidden', 'important');
        else flPrec.style.removeProperty('visibility');
      }
      el.setAttribute('active-index', String(courant));
    }

    function reposer() {
      rang = boucle ? n : courant;
      placer(positionDe(rang), 0);
      peindre();
    }

    function aller(sens) {
      if (!pas) return;
      if (finAnim) { finAnim(); }                          // un clic rapide finit le geste en cours
      if (boucle) {
        placer(positionDe(rang + sens), VITESSE);
        courant = (courant + sens + n) % n;
        var fini = false;
        finAnim = function () {
          if (fini) return;
          fini = true;
          clearTimeout(minuteur);
          finAnim = null;
          tourner(sens);
          reposer();
        };
        var minuteur = setTimeout(finAnim, VITESSE);
      } else {
        var vise = Math.max(0, Math.min(n - 1, courant + sens));
        if (vise === courant) return;
        courant = vise;
        rang = courant;
        placer(positionDe(rang), VITESSE);
        peindre();
      }
    }

    function viser(k) {
      if (boucle) {
        var ecart = ((k - courant) % n + n) % n;
        if (!ecart) return;
        aller(ecart <= n / 2 ? 1 : -1);                    // un cran a la fois, comme la source
      } else {
        var vise = Math.max(0, Math.min(n - 1, k));
        if (vise === courant) return;
        courant = vise; rang = courant;
        placer(positionDe(rang), VITESSE);
        peindre();
      }
    }

    if (flPrec) flPrec.addEventListener('click', function (e) { e.preventDefault(); aller(-1); });
    if (flSuiv) flSuiv.addEventListener('click', function (e) { e.preventDefault(); aller(1); });
    if (dots) dots.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('.gp-carousel-dot') : null;
      if (!b) return;
      e.preventDefault();
      viser(parseInt(b.getAttribute('data-index'), 10) || 0);
    });

    /* -------- glisser tactile : `enableDrag:{desktop:true}` sur la source. */
    var pid = null, x0 = 0, dx = 0, glisse = false;
    piste.addEventListener('pointerdown', function (e) {
      if (!pas || finAnim) return;
      pid = e.pointerId; x0 = e.clientX; dx = 0; glisse = false;
      placer(positionDe(rang), 0);
    });
    piste.addEventListener('pointermove', function (e) {
      if (e.pointerId !== pid) return;
      dx = e.clientX - x0;
      if (!glisse && Math.abs(dx) > 6) glisse = true;
      if (glisse) {
        e.preventDefault();
        placer(positionDe(rang) + dx, 0);
      }
    });
    function relacher(e) {
      if (e.pointerId !== pid) return;
      pid = null;
      if (!glisse) return;
      var seuil = pas / 4;
      if (dx <= -seuil) aller(1);
      else if (dx >= seuil) aller(-1);
      else placer(positionDe(rang), VITESSE);
      glisse = false;
    }
    piste.addEventListener('pointerup', relacher);
    piste.addEventListener('pointercancel', relacher);
    piste.addEventListener('dragstart', function (e) { if (glisse) e.preventDefault(); });

    /* -------- pose initiale + suivi des paliers. */
    var mqMobile = window.matchMedia('(max-width: 767px)');
    function poser() {
      var veut = mqMobile.matches;                         // `loop = {desktop:false, mobile:true}`
      if (veut !== boucle) { boucle = veut; poserClones(boucle); courant = 0; }
      if (!boucle && courant > n - 1) courant = n - 1;
      /* Un cadre non mesurable interdit la GEOMETRIE, pas le BALISAGE : la source peuple ses
         puces meme quand la rangee est `--d:none`. Sortir ici laissait le conteneur vide et
         creusait un ecart de 3 noeuds a 1440, invisible a l'oeil et visible au banc. */
      if (!mesurer()) { peindre(); return; }
      reposer();
    }
    poserClones(mqMobile.matches);
    boucle = mqMobile.matches;
    poser();
    if (mqMobile.addEventListener) mqMobile.addEventListener('change', poser);
    var rt = null;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(poser, 150);
    });
  }

  /* ------------------------------------------------------------------ AMORCAGE */
  function demarrer() {
    all(ROOT).forEach(function (racine) {
      all('gp-countdown-timer', racine).forEach(rebours);
      all('gp-accordion', racine).forEach(accordeon);
      all('gp-carousel-v3', racine).forEach(carrousel);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
